import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import get from 'lodash/get';
import * as Yup from 'yup';

import { usePutOrganization } from 'api';

import { Button, Modal } from 'components/ui';
import { General } from './components';
import ToastMessage from 'components/toastMessage';

import * as Styled from './OrganizationTaxEditModal.styles';

const schema = Yup.object({
    kod: Yup.string().trim().required('Pole wymagane'),
    nazwa: Yup.string().trim().required('Pole wymagane'),
});

export const OrganizationTaxEditModal = ({ onClose, onSuccess, organizationData }) => {
  const [toastData, setToastData] = useState(null);

  const { mutate: updateOrganization, isLoading: isUpdatingOrganizationData } = usePutOrganization({
    onSuccess: () => {
      onSuccess();
    },
    onError: () => {
      setToastData({ severity: 'error', message: 'Nie udało się zapisać ustawień' });
    },
  });

  const formik = useFormik({
    initialValues: {
        kod: get(organizationData, 'organization.urzadSkarbowy.kod', '') || '',
        nazwa: get(organizationData, 'organization.urzadSkarbowy.nazwa', '') || '',
    },
    validationSchema: schema,
    validateOnChange: false,
    enableReinitialize: true,
    onSubmit: (values) => {
      updateOrganization({ urzadSkarbowy: schema.cast(values) });
    },
  });

  return (
    <Modal title="Urząd skarbowy" onClose={onClose}>
      <Styled.Form>
        <General
          form={formik}
        />
      </Styled.Form>
      <Styled.Actions>
        <Button onClick={onClose} variant="outlined">
          Anuluj
        </Button>

        <Button onClick={formik.handleSubmit} loading={formik.isValidating || isUpdatingOrganizationData}>
          Zapisz
        </Button>
      </Styled.Actions>

      {toastData && (
        <ToastMessage
          open
          onClose={() => setToastData(null)}
          severity={toastData.severity}
          message={toastData.message}
        />
      )}
    </Modal>
  );
};

OrganizationTaxEditModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  organizationData: PropTypes.object.isRequired,
};
